import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 35,
  medium: 27,
  small: 17,
  xSmall: 14
};
const BackIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement("path", { d: "M3.911 14.25L11.5 6.7L10.7963 6L2 14.75L10.7963 23.5L11.5 22.8L3.91099 15.25H27V14.25H3.911Z", fill: "currentColor" })
  );
};
BackIcon.iconName = "BackIcon";

export { BackIcon };
